<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >
                    
                    <div class="hidden-lg hidden-md hidden-xl">    
                        <center>
                            <img src="/static/images/logo.png" class="logo-inicio">
                        </center>
                    </div>
                    <div class="hidden-xs">    
                        <center>
                            <img src="/static/images/logo.png" class="logo-inicio">
                        </center>
                    </div>      

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs hidden-md">
                        <h3>
                            {{$router.currentRoute.meta.title}}
                        </h3>
                    </div>                                  
            
                    <div class="row" v-show="$root.user.tipo == 'contratante' || $root.user.tipo == 'admin' || $root.user.tipo == 'marketing'">
                        <div class="col-xs-12 col-xl-8 col-lg-8">
                            <div class="row">
                                <div class="col-xs-12 col-xl-12">
                                    <div class="dashboard-box margin-top-0 cards">
                                        <div class="content">
                                            <h5 class="block-title">
                                                <i class="material-icons">comment</i>
                                                Mural de recados
                                            </h5>
                                            <ul class="dashboard-box-list">
                                                
                                                <li v-for="(item, index) in data.mural.itens">
                                                    <a class="job-listing card2" style="border-color: rgba(225, 229, 76, 0.3)">
                                                        <div class="job-listing-details">
                                                            <div class="job-listing-description" style="padding-top: 0px;">
                                                                <div class="row">
                                                                    <div class="col-lg-12">
                                                                        <p style="line-height: 110%; padding-top: 0px; margin-top: 3px;">
                                                                            {{item.objeto.conteudo}}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </li>

                                            </ul>
                                        </div>
                                    </div>  
                                </div>                          

                                <div class="col-xs-12 col-lg-12 col-xl-12" v-show="$root.user.tipo == 'contratante'">
                                    <div class="dashboard-box margin-top-0 cards" v-if="$root.logged">
                                        <div class="content" v-if="data.agendamentos.itens.length > 0">
                                            <h5 class="block-title">
                                                <i class="material-icons">event</i>
                                                Próximos agendamentos
                                            </h5>
                                            <ul class="dashboard-box-list">
                                                
                                                <li v-for="(item, index) in agendamentosProximos">
                                                    <router-link v-if="item.DS_CLASSIF_AGENDA == 'Consulta Online'" :to="{'name': 'Teleconsulta', 'query': {'NR_SEQUENCIA': item.NR_SEQUENCIA}}" class="job-listing card2" style="border-color: rgba(29, 157, 217, 0.4)">
                                                        <div class="job-listing-details">
                                                            <div class="job-listing-description">
                                                                <div class="row">
                                                                    <div class="col-lg-12">
                                                                        <i class="material-icons chevron-right hidden-xl hidden-lg" style="opacity: 0.5">arrow_right</i>
                                                                        <h3 class="job-listing-title margin-bottom-0" style="color: #666;">
                                                                            <i class="material-icons" style="opacity: 0.5;">access_time</i>    
                                                                            {{item.HR_INICIO | formatDate}}h
                                                                        </h3>
                                                                        <small style="display: block; line-height: 130%; margin-bottom: 5px;">
                                                                            <i class="material-icons">people</i>
                                                                            {{item.NM_MEDICO_AGENDA}}
                                                                        </small>
                                                                        <span class="dashboard-status-button" style="letter-spacing: 1px; font-size: 12px;" :class="{'green': item.DS_STATUS_AGENDA == 'Executada' || item.DS_STATUS_AGENDA == 'Atendido', 'color-orange': item.DS_STATUS_AGENDA == 'Aguardando', 'color-red': item.DS_STATUS_AGENDA == 'Cancelada' || item.DS_STATUS_AGENDA == 'Falta não justificada', 'color-blue': item.DS_STATUS_AGENDA == 'Em Consulta', 'color-gray': item.DS_STATUS_AGENDA == 'Normal'}">
                                                                            {{item.DS_STATUS_AGENDA}}
                                                                        </span>

                                                                        <small v-if="item.DS_CLASSIF_AGENDA == 'Consulta Online'" style="color: #000">
                                                                            <i class="material-icons">videocam</i>
                                                                            Teleconsulta
                                                                        </small>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </router-link>
                                                    <router-link v-if="item.DS_CLASSIF_AGENDA != 'Consulta Online'" :to="{'name': 'Agendamentos'}" class="job-listing card2" style="border-color: rgba(29, 157, 217, 0.4)">
                                                        <div class="job-listing-details">
                                                            <div class="job-listing-description">
                                                                <div class="row">
                                                                    <div class="col-lg-12">
                                                                        <i class="material-icons chevron-right hidden-xl hidden-lg" style="opacity: 0.5">arrow_right</i>
                                                                        <h3 class="job-listing-title margin-bottom-0" style="color: #666;">
                                                                            <i class="material-icons" style="opacity: 0.5;">access_time</i>    
                                                                            {{item.HR_INICIO | formatDate}}h
                                                                        </h3>
                                                                        <small style="display: block; line-height: 130%; margin-bottom: 5px;">
                                                                            <i class="material-icons">people</i>
                                                                            {{item.NM_MEDICO_AGENDA}}
                                                                        </small>
                                                                        <span class="dashboard-status-button" style="letter-spacing: 1px; font-size: 12px;" :class="{'green': item.DS_STATUS_AGENDA == 'Executada' || item.DS_STATUS_AGENDA == 'Atendido', 'color-orange': item.DS_STATUS_AGENDA == 'Aguardando', 'color-red': item.DS_STATUS_AGENDA == 'Cancelada' || item.DS_STATUS_AGENDA == 'Falta não justificada', 'color-blue': item.DS_STATUS_AGENDA == 'Em Consulta', 'color-gray': item.DS_STATUS_AGENDA == 'Normal'}">
                                                                            {{item.DS_STATUS_AGENDA}}
                                                                        </span>

                                                                        <small v-if="item.DS_CLASSIF_AGENDA == 'Consulta Online'" style="color: #000">
                                                                            <i class="material-icons">switch_video</i>
                                                                            Teleconsulta
                                                                        </small>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </router-link>
                                                </li>

                                            </ul>
                                        </div>
                                    </div>  
                                    <div class="dashboard-box margin-top-0 cards" v-show="!$root.logged">
                                        <div class="content">
                                            <h5 class="block-title">
                                                <i class="material-icons">lock</i>
                                                Cadastre-se ou faça login
                                            </h5>
                                            <ul class="dashboard-box-list">
                                                
                                                <li>
                                                    <router-link :to="{'name': 'Login'}" class="job-listing card2" style="border-color: rgba(29, 157, 217, 0.4)">
                                                        <div class="job-listing-details">
                                                            <div class="job-listing-description">
                                                                <div class="row">
                                                                    <div class="col-lg-12">
                                                                        <h4 class="job-listing-title" style="color: #666; line-height: 120%; font-size: 14px;">
                                                                            <!-- <i class="material-icons" style="opacity: 0.5;">account_circle</i>     -->
                                                                            Toque aqui e acesse sua conta para visualizar agendamentos e muito mais.
                                                                        </h4>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </router-link>
                                                </li>

                                            </ul>
                                        </div>
                                    </div>                              
                                    <!-- <div class="hidden-xs margin-top-20"></div>                          -->
                                </div>
                              
                                <div class="col-xs-12 col-xl-12 col-lg-12" v-if="$root.user.tipo == 'contratante'">
                                    <div class="row">

                                        <div class="col-xs-6 col-xl-4 col-md-6 col-lg-3">
                                            <router-link :to="{'name': 'Profissionais'}" class="button-menu shadow">
                                                <img src="static/images/icones/stethoscope.png">
                                                Agendar consulta
                                            </router-link>
                                        </div>

                                        <div class="col-xs-6 col-xl-4 col-md-6 col-lg-3">
                                            <router-link :to="{'name': 'Agendamentos'}" class="button-menu shadow">
                                                <img src="static/images/icones/calendar.png">
                                                Meus agendamentos
                                            </router-link>
                                        </div>

                                        <div class="col-xs-6 col-xl-4 col-md-6 col-lg-3">
                                            <router-link :to="{'name': 'Posts'}" class="button-menu shadow">
                                                <img src="/static/images/icones/writing.png">
                                                Dicas semanais
                                            </router-link>
                                        </div>

                                        <div class="col-xs-6 col-xl-4 col-md-6 col-lg-3">
                                            <router-link :to="{'name': 'Receitas'}" class="button-menu shadow">
                                                <img src="static/images/icones/note.png">
                                                Receitas e atestados
                                            </router-link>
                                        </div>

                                        <div class="col-xs-6 col-xl-4 col-md-6 col-lg-3">
                                            <router-link :to="{'name': 'Arquivos'}" class="button-menu shadow">
                                                <img src="static/images/icones/archives.png">
                                                Meus exames
                                            </router-link>
                                        </div>

                                        <div class="col-xs-6 col-xl-4 col-md-6 col-lg-3">
                                            <router-link :to="{'name': 'Conta'}" class="button-menu shadow">
                                                <img src="static/images/icones/profile.png">
                                                Minha conta
                                            </router-link>
                                        </div>

                                        <div class="col-xs-12 col-xl-6 margin-bottom-15 hidden-xl hidden-lg">
                                            <a class="button-menu shadow convenios" style="">
                                                <div class="row margin-bottom-25">
                                                    <div class="col-xl-12" style="text-align: center; padding-top: 5px;">
                                                        <h4 style="font-size: 120%;">Aceitamos seu<br><b>Plano De Saúde</b></h4>
                                                    </div>
                                                    <div class="col-xl-12">

                                                        <swiper ref="swiperConvenios" :options="swiperOptions">
                                                            <swiper-slide>
                                                                <img src="/static/images/convenios/unafisco.png">
                                                            </swiper-slide>
                                                            <swiper-slide>
                                                                <img src="/static/images/convenios/temposaude.png">
                                                            </swiper-slide>
                                                            <swiper-slide>
                                                                <img src="/static/images/convenios/scsaude.png">
                                                            </swiper-slide>                               
                                                            <swiper-slide>
                                                                <img src="/static/images/convenios/sicoob.png">
                                                            </swiper-slide>
                                                            <swiper-slide>
                                                                <img src="/static/images/convenios/postalsaude.png">
                                                            </swiper-slide>                                                                                                                         
                                                            <swiper-slide>
                                                                <img src="/static/images/convenios/pladisa.png">
                                                            </swiper-slide>
                                                            <swiper-slide>
                                                                <img src="/static/images/convenios/petrobras.jpg">
                                                            </swiper-slide>
                                                            <swiper-slide>
                                                                <img src="/static/images/convenios/renner.jpg">
                                                            </swiper-slide>
                                                            <swiper-slide>
                                                                <img src="/static/images/convenios/saudeconceicao.jpg">
                                                            </swiper-slide>
                                                            <swiper-slide>
                                                                <img src="/static/images/convenios/saudecaixa.jpg">
                                                            </swiper-slide>
                                                            <swiper-slide>
                                                                <img src="/static/images/convenios/sulamericasaude.jpg">
                                                            </swiper-slide>
                                                            <swiper-slide>
                                                                <img src="/static/images/convenios/unimed.jpg">
                                                            </swiper-slide>     
                                                            <swiper-slide>
                                                                <img src="/static/images/convenios/vonpar.jpg">
                                                            </swiper-slide>                              
                                                            <swiper-slide>
                                                                <img src="/static/images/convenios/elosaude.png">
                                                            </swiper-slide>
                                                            <swiper-slide>
                                                                <img src="/static/images/convenios/paranaclinicassaude.png">
                                                            </swiper-slide>
                                                            <swiper-slide>
                                                                <img src="/static/images/convenios/marinhadobrasil.jpg">
                                                            </swiper-slide>
                                                            <swiper-slide>
                                                                <img src="/static/images/convenios/medservice.jpg">
                                                            </swiper-slide>
                                                            <swiper-slide>
                                                                <img src="/static/images/convenios/goldencross.jpg">
                                                            </swiper-slide>
                                                            <swiper-slide>
                                                                <img src="/static/images/convenios/gamasaude.jpg">
                                                            </swiper-slide>
                                                            <swiper-slide>
                                                                <img src="/static/images/convenios/geapsaude.jpg">
                                                            </swiper-slide>
                                                            <swiper-slide>
                                                                <img src="/static/images/convenios/funservir.jpg">
                                                            </swiper-slide>
                                                            <swiper-slide>
                                                                <img src="/static/images/convenios/eletrosul.jpg">
                                                            </swiper-slide>
                                                            <swiper-slide>
                                                                <img src="/static/images/convenios/cassi.jpg">
                                                            </swiper-slide>
                                                            <swiper-slide>
                                                                <img src="/static/images/convenios/capesep.jpg">
                                                            </swiper-slide>
                                                            <swiper-slide>
                                                                <img src="/static/images/convenios/bradescosaude.jpg">
                                                            </swiper-slide>
                                                            <swiper-slide>
                                                                <img src="/static/images/convenios/fundacaoassefaz.jpg">
                                                            </swiper-slide>
                                                            <swiper-slide>
                                                                <img src="/static/images/convenios/aspmi.jpg">
                                                            </swiper-slide>
                                                            <swiper-slide>
                                                                <img src="/static/images/convenios/amil.jpg">
                                                            </swiper-slide>
                                                            <swiper-slide>
                                                                <img src="/static/images/convenios/celos.png">
                                                            </swiper-slide>
                                                            <swiper-slide>
                                                                <img src="/static/images/convenios/cabergssaude.png">
                                                            </swiper-slide>  

                                                            <div class="swiper-pagination" slot="pagination"></div>                                                                                                      
                                                        </swiper>                                                

                                                        <router-link :to="{'name': 'Convenios'}">
                                                            <u>Veja todos os <b>convênios</b></u>
                                                        </router-link>

                                                    </div>
                                                </div>
                                            </a>
                                        </div>

                                        <div class="col-xs-12 col-xl-6 contato hidden-xl hidden-lg" v-show="$root.user.tipo == 'contratante'">
                                            <a class="button-menu shadow" style="min-height: 17vh; height: auto; padding-top: 20px;">
                                                <div class="row">
                                                    <div class="col-xl-7 col-xs-7" style="text-align: left; padding-top: 5px; padding-left: 15px;">
                                                        <h4 style="font-size: 120%">Fale conosco!</h4>
                                                        <small>
                                                            Estamos prontos para lhe atender.
                                                        </small>
                                                        <div style="height: 10px"></div>
                                                        <a href="tel:4733485093" target="_blank" class="social">
                                                            <img src="/static/images/icones/phone.png">
                                                        </a>
                                                        <a href="https://api.whatsapp.com/send?phone=5547992797624&text=" target="_blank" class="social">
                                                            <img src="/static/images/icones/whatsapp.png">
                                                        </a>
                                                        <a href="https://instagram.com/neoplasiaslitoral" target="_blank" class="social">
                                                            <img src="/static/images/icones/instagram.png">
                                                        </a>
                                                        <a href="https://www.facebook.com/neoplasiaslitoral" target="_blank" class="social">
                                                            <img src="/static/images/icones/facebook.png">
                                                        </a>  
        <!--                                                 <a href="" class="social">
                                                            <img src="/static/images/icones/email.png">
                                                        </a>         -->                                                                                               
                                                        <div style="height: 10px"></div>

                                                    </div>
                                                    <div class="col-xl-5 col-xs-5">
                                                        <center>
                                                            <img src="static/images/icones/message.png">
                                                        </center>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>

                                    </div>                            
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 contato hidden-xs hidden-md margin-top-30" v-show="$root.user.tipo == 'contratante'">
                            <a class="button-menu shadow" style="min-height: 17vh; height: auto; padding-top: 20px;">
                                <div class="row">
                                    <div class="col-xl-7 col-xs-7" style="text-align: left; padding-top: 5px; padding-left: 15px;">
                                        <h4 style="font-size: 120%">Fale conosco!</h4>
                                        <small>
                                            Estamos prontos para lhe atender.
                                        </small>
                                        <div style="height: 10px"></div>
                                        <a :href="$root.config.telefone" target="_blank" class="social">
                                            <img src="/static/images/icones/phone.png">
                                        </a>
                                        <a :href="$root.config.whatsapp" target="_blank" class="social">
                                            <img src="/static/images/icones/whatsapp.png">
                                        </a>
                                        <a :href="$root.config.instagram" target="_blank" class="social">
                                            <img src="/static/images/icones/instagram.png">
                                        </a>
                                        <a :href="$root.config.facebook" target="_blank" class="social">
                                            <img src="/static/images/icones/facebook.png">
                                        </a>  
    <!--                                                 <a href="" class="social">
                                            <img src="/static/images/icones/email.png">
                                        </a>         -->                                                                                               
                                        <div style="height: 10px"></div>

                                    </div>
                                    <div class="col-xl-5 col-xs-5">
                                        <center>
                                            <img src="static/images/icones/message.png">
                                        </center>
                                    </div>
                                </div>
                            </a>
                            <a class="button-menu shadow convenios" style="height: auto !important;">
                                <div class="row margin-bottom-25">
                                    <div class="col-xl-12" style="text-align: center; padding-top: 5px;">
                                        <h4 style="font-size: 120%;">Aceitamos seu<br><b>Plano De Saúde</b></h4>
                                    </div>
                                    <div class="col-xl-12">

                                        <swiper ref="swiperConvenios" :options="swiperOptions">
                                            <swiper-slide>
                                                <img src="/static/images/convenios/unafisco.png">
                                            </swiper-slide>
                                            <swiper-slide>
                                                <img src="/static/images/convenios/temposaude.png">
                                            </swiper-slide>
                                            <swiper-slide>
                                                <img src="/static/images/convenios/scsaude.png">
                                            </swiper-slide>                               
                                            <swiper-slide>
                                                <img src="/static/images/convenios/sicoob.png">
                                            </swiper-slide>
                                            <swiper-slide>
                                                <img src="/static/images/convenios/postalsaude.png">
                                            </swiper-slide>                                                                                                                         
                                            <swiper-slide>
                                                <img src="/static/images/convenios/pladisa.png">
                                            </swiper-slide>
                                            <swiper-slide>
                                                <img src="/static/images/convenios/petrobras.jpg">
                                            </swiper-slide>
                                            <swiper-slide>
                                                <img src="/static/images/convenios/renner.jpg">
                                            </swiper-slide>
                                            <swiper-slide>
                                                <img src="/static/images/convenios/saudeconceicao.jpg">
                                            </swiper-slide>
                                            <swiper-slide>
                                                <img src="/static/images/convenios/saudecaixa.jpg">
                                            </swiper-slide>
                                            <swiper-slide>
                                                <img src="/static/images/convenios/sulamericasaude.jpg">
                                            </swiper-slide>
                                            <swiper-slide>
                                                <img src="/static/images/convenios/unimed.jpg">
                                            </swiper-slide>     
                                            <swiper-slide>
                                                <img src="/static/images/convenios/vonpar.jpg">
                                            </swiper-slide>                              
                                            <swiper-slide>
                                                <img src="/static/images/convenios/elosaude.png">
                                            </swiper-slide>
                                            <swiper-slide>
                                                <img src="/static/images/convenios/paranaclinicassaude.png">
                                            </swiper-slide>
                                            <swiper-slide>
                                                <img src="/static/images/convenios/marinhadobrasil.jpg">
                                            </swiper-slide>
                                            <swiper-slide>
                                                <img src="/static/images/convenios/medservice.jpg">
                                            </swiper-slide>
                                            <swiper-slide>
                                                <img src="/static/images/convenios/goldencross.jpg">
                                            </swiper-slide>
                                            <swiper-slide>
                                                <img src="/static/images/convenios/gamasaude.jpg">
                                            </swiper-slide>
                                            <swiper-slide>
                                                <img src="/static/images/convenios/geapsaude.jpg">
                                            </swiper-slide>
                                            <swiper-slide>
                                                <img src="/static/images/convenios/funservir.jpg">
                                            </swiper-slide>
                                            <swiper-slide>
                                                <img src="/static/images/convenios/eletrosul.jpg">
                                            </swiper-slide>
                                            <swiper-slide>
                                                <img src="/static/images/convenios/cassi.jpg">
                                            </swiper-slide>
                                            <swiper-slide>
                                                <img src="/static/images/convenios/capesep.jpg">
                                            </swiper-slide>
                                            <swiper-slide>
                                                <img src="/static/images/convenios/bradescosaude.jpg">
                                            </swiper-slide>
                                            <swiper-slide>
                                                <img src="/static/images/convenios/fundacaoassefaz.jpg">
                                            </swiper-slide>
                                            <swiper-slide>
                                                <img src="/static/images/convenios/aspmi.jpg">
                                            </swiper-slide>
                                            <swiper-slide>
                                                <img src="/static/images/convenios/amil.jpg">
                                            </swiper-slide>
                                            <swiper-slide>
                                                <img src="/static/images/convenios/celos.png">
                                            </swiper-slide>
                                            <swiper-slide>
                                                <img src="/static/images/convenios/cabergssaude.png">
                                            </swiper-slide>  

                                            <div class="swiper-pagination" slot="pagination"></div>                                                                                                      
                                        </swiper>                                                

                                        <router-link :to="{'name': 'Convenios'}">
                                            <u>Veja todos os <b>convênios</b></u>
                                        </router-link>

                                    </div>
                                </div>
                            </a>
                        </div>    
                        <div class="col-xs-12 col-xl-4 margin-bottom-15 hidden-xs hidden-md">
                        </div>                                              
                    </div>

                    <!-- admin -->
                    <div class="row" v-show="$root.user.tipo == 'admin'">
                           
                        <div class="col-xs-12">
                            <div class="row">

                                <div class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Posts'}" class="button-menu shadow">
                                        <img src="/static/images/icones/writing.png">
                                        Dicas semanais
                                    </router-link>
                                </div>

                                <div class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Agendamentos'}" class="button-menu shadow">
                                        <img src="static/images/icones/calendar.png">
                                        Agendamentos
                                    </router-link>
                                </div>


<!--                                 <div class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Profissionais'}" class="button-menu shadow">
                                        <img src="static/images/icones/stethoscope.png">
                                        Profissionais
                                    </router-link>
                                </div>
 -->
                                <div class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Pacientes'}" class="button-menu shadow">
                                        <img src="static/images/icones/users.png">
                                        Pacientes
                                    </router-link>
                                </div>

                                <div class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Receitas'}" class="button-menu shadow">
                                        <img src="static/images/icones/note.png">
                                        Receitas e atestados
                                    </router-link>
                                </div>

                                <div class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Campanhas'}" class="button-menu shadow">
                                        <img src="static/images/icones/tick.png">
                                        Campanhas
                                    </router-link>
                                </div>

                                <div class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Mural'}" class="button-menu shadow">
                                        <img src="static/images/icones/document.png">
                                        Mural de recados
                                    </router-link>
                                </div>

<!--                                 <div class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Relatorios'}" class="button-menu shadow">
                                        <img src="static/images/icones/page.png">
                                        Relatórios
                                    </router-link>
                                </div>                                    -->           

                                <div class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'UsuariosGeral'}" class="button-menu shadow">
                                        <img src="static/images/icones/user2.png">
                                        Usuários
                                    </router-link>
                                </div>

                                <div class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Configuracoes'}" class="button-menu shadow">
                                        <img src="static/images/icones/gear.png">
                                        Configurações
                                    </router-link>
                                </div>   


                                <div class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Conta'}" class="button-menu shadow">
                                        <img src="static/images/icones/profile.png">
                                        Minha conta
                                    </router-link>
                                </div>

                            </div>                            
                        </div>                            
                        
                    </div>

                    <!-- admin -->
                    <div class="row" v-show="$root.user.tipo == 'marketing'">
                           
                        <div class="col-xs-12">
                            <div class="row">

                                <div class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Posts'}" class="button-menu shadow">
                                        <img src="/static/images/icones/writing.png">
                                        Dicas semanais
                                    </router-link>
                                </div>

                                <div class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Campanhas'}" class="button-menu shadow">
                                        <img src="static/images/icones/tick.png">
                                        Campanhas
                                    </router-link>
                                </div>

                                <div class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Mural'}" class="button-menu shadow">
                                        <img src="static/images/icones/document.png">
                                        Mural de recados
                                    </router-link>
                                </div>

                                <div class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Conta'}" class="button-menu shadow">
                                        <img src="static/images/icones/profile.png">
                                        Minha conta
                                    </router-link>
                                </div>

                            </div>                            
                        </div>                            
                        
                    </div>                    

                    <!-- profissional -->
                    <div class="row" v-show="$root.user.tipo == 'profissional'">
                        <div class="col-xs-12" v-if="data.agendamentos.itens.length > 0">                         
                            <div class="dashboard-box margin-top-0 cards agendamentos">
                                <div class="content">
                                    <h5 class="block-title">
                                        <i class="material-icons">event</i>
                                        Agendamentos hoje
                                    </h5>
                                    <ul class="dashboard-box-list">
                                        
                                        <li v-for="(item, index) in data.agendamentos.itens">
                                            <router-link v-if="item.DS_CLASSIF_AGENDA != 'Consulta Online'" :to="{'name': 'Paciente', 'query':{'CD_PESSOA_FISICA': item.CD_PESSOA_FISICA}}" class="job-listing card2" style="border-color: rgba(29, 157, 217, 0.4)">
                                                <div class="job-listing-details">
                                                    <div class="job-listing-description">
                                                        <div class="row">
                                                            <div class="col-lg-12">
                                                                <i class="material-icons chevron-right hidden-xl hidden-md" style="opacity: 0.5">arrow_right</i>
                                                                <h3 class="job-listing-title margin-bottom-0" style="color: #666;">
                                                                    <i class="material-icons" style="opacity: 0.5;">access_time</i>    
                                                                    {{item.HR_INICIO | formatDate}}h
                                                                </h3>
                                                                <small style="display: block; line-height: 130%; margin-bottom: 5px;">
                                                                    <i class="material-icons">person</i>
                                                                    #{{item.CD_PESSOA_FISICA}} - {{item.NM_PACIENTE}}
                                                                </small>
                                                                <span class="dashboard-status-button" style="letter-spacing: 1px; font-size: 12px;" :class="{'green': item.DS_STATUS_AGENDA == 'Executada' || item.DS_STATUS_AGENDA == 'Atendido', 'color-orange': item.DS_STATUS_AGENDA == 'Aguardando', 'color-red': item.DS_STATUS_AGENDA == 'Cancelada' || item.DS_STATUS_AGENDA == 'Falta não justificada', 'color-blue': item.DS_STATUS_AGENDA == 'Em Consulta', 'color-gray': item.DS_STATUS_AGENDA == 'Normal'}">
                                                                    {{item.DS_STATUS_AGENDA}}
                                                                </span>    

<!--                                                                 <small>
                                                                    <i class="material-icons">store</i>
                                                                    Presencial
                                                                </small> -->

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </router-link>
                                            <router-link v-if="item.DS_CLASSIF_AGENDA == 'Consulta Online'" :to="{'name': 'Teleconsulta', 'query': {'NR_SEQUENCIA': item.NR_SEQUENCIA}}" class="job-listing card2" style="border-color: rgba(29, 157, 217, 0.4)">
                                                <div class="job-listing-details">
                                                    <div class="job-listing-description">
                                                        <div class="row">
                                                            <div class="col-lg-12">
                                                                <i class="material-icons chevron-right hidden-xl hidden-lg" style="opacity: 0.5">arrow_right</i>
                                                                <h3 class="job-listing-title margin-bottom-0" style="color: #666;">
                                                                    <i class="material-icons" style="opacity: 0.5;">access_time</i>    
                                                                    {{item.HR_INICIO | formatDate}}h
                                                                </h3>
                                                                <small style="display: block; line-height: 130%; margin-bottom: 5px;">
                                                                    <i class="material-icons">person</i>
                                                                    #{{item.CD_PESSOA_FISICA}} - {{item.NM_PACIENTE}}
                                                                </small>
                                                                <span class="dashboard-status-button" style="letter-spacing: 1px; font-size: 12px;" :class="{'green': item.DS_STATUS_AGENDA == 'Executada' || item.DS_STATUS_AGENDA == 'Atendido', 'color-orange': item.DS_STATUS_AGENDA == 'Aguardando', 'color-red': item.DS_STATUS_AGENDA == 'Cancelada' || item.DS_STATUS_AGENDA == 'Falta não justificada', 'color-blue': item.DS_STATUS_AGENDA == 'Em Consulta', 'color-gray': item.DS_STATUS_AGENDA == 'Normal'}">
                                                                    {{item.DS_STATUS_AGENDA}}
                                                                </span>

                                                                <small v-if="item.DS_CLASSIF_AGENDA == 'Consulta Online'" style="color: #000">
                                                                    <i class="material-icons">videocam</i>
                                                                    Teleconsulta
                                                                </small>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>  
                            <div class="hidden-xs margin-top-20"></div>                         
                        </div>
                        <div class="col-xs-12">
                            <div class="row">

                                <div class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Agendamentos'}" class="button-menu shadow">
                                        <img src="static/images/icones/calendar.png">
                                        Agendamentos
                                    </router-link>
                                </div>

                                <div class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Pacientes'}" class="button-menu shadow">
                                        <img src="static/images/icones/users.png">
                                        Pacientes
                                    </router-link>
                                </div>

                                <div class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Receitas'}" class="button-menu shadow">
                                        <img src="static/images/icones/note.png">
                                        Receitas e atestados
                                    </router-link>
                                </div>

                                <div class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Conta'}" class="button-menu shadow">
                                        <img src="static/images/icones/profile.png">
                                        Minha conta
                                    </router-link>
                                </div>

                            </div>                            
                        </div>                            
                        

                    </div>                    


                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Dashboard',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },     
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }

            // return formatDate(value.replace(" ", "T")) + " " + formatHours(value.replace(" ", "T"));
            return date + (time ? (" " + time) : "");
        }
    },        
    data () {
        var self                    = this;
        return {
            // "agendamentosProximos": [],
            "loaded":               false,
            "initLoaded":           false,
            "swiperOptions": {
                "speed":            400,
                //     "pagination": {
                //     "el": '.swiper-pagination'
                // },                
                "autoplay":         {
                    "delay":        1000
                },
                "slidesPerView":    "2",
                "spaceBetween":     10
            },               
            "data":                 {
                "agendamentos":     {
                    "itens":        []
                },
                "mural":     {
                    "itens":        []
                },
            },
            "loading": {
                "submit":           false
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "tipo":             "agendamento",
                "filtro":           "pendentes"
            }              
        }
    },
    computed: {
        agendamentosProximos: function () {
            function compare(a, b) {
                if ((new Date(a.HR_INICIO)).getTime() < (new Date(b.HR_INICIO)).getTime())
                    return -1;
                if ((new Date(a.HR_INICIO)).getTime() > (new Date(b.HR_INICIO)).getTime())
                    return 1;
                return 0;
            }
            return this.data.agendamentos.itens.sort(compare);
        }
    },    
    methods: {
        getMetricas: function() {
            var self        = this;
            console.log("getMetricas()", self.form);
            // loading.show();
            return new Promise(function(resolve, reject) {

                if (self.$root.user.tipo != "admin") {
                    return resolve(true);
                };

                if (self.$root.user.tipo == "admin" || self.$root.user.tipo == "profissional") {
                    self.form.filtro    = "hoje";
                }

                axios.get("api/metricas.php", {params: self.form})
                .then(response => {
                    
                    console.log("getMetricas() response", response);    
                    self.data.metricas               = response.data.result; 
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getMetricas() error", error);                    
                    // loading.hide();
                    reject(error);
                    // alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        }, 
        getMural: function() {
            var self        = this;
            console.log("getMural()", self.form);
            // loading.show();
            return new Promise(function(resolve, reject) {

                if (self.$root.tmp.dashboardMural.itens.length > 0) {
                    self.data.mural  = JSON.parse(JSON.stringify(self.$root.tmp.dashboardMural));
                    self.$root.loaded = true;
                    self.initLoaded = true;
                    self.$forceUpdate();
                    loading.hide();
                    resolve(true);
                    console.log("RESOLVEU PROMISE")
                }

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "multiplo":     true,
                        "nome":         "mural",
                        "habilitado":   1
                    }
                };

                axios.get("api/itens.php", form)
                .then(response => {
                    
                    console.log("getMural() response", response);    
                    self.data.mural               = response.data.result; 
                    self.$root.tmp.dashboardMural = JSON.parse(JSON.stringify(response.data.result));
                    self.$forceUpdate();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getMural() error", error);                    
                    // loading.hide();
                    reject(error);
                    // alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },         
        getAgendamentos: function() {
            var self        = this;
            console.log("getAgendamentos()", self.form);
            // loading.show();
            return new Promise(function(resolve, reject) {

                if (!self.$root.logged) {
                    return resolve(true);
                }

                if (self.$root.tmp.dashboardAgendamentos.itens.length > 0) {
                    self.data.agendamentos  = JSON.parse(JSON.stringify(self.$root.tmp.dashboardAgendamentos));
                    self.$forceUpdate();
                    resolve(true);
                    console.log("RESOLVEU PROMISE")
                }
                
                if (self.$root.user.tipo == "profissional") {
                    self.form.filtro    = "hoje";
                } else if (self.$root.user.tipo == "contratante") {
                    self.form.filtro    = "proximos";
                } else {   
                    return resolve(true);
                }
                console.log("FEZ REQUEST")

                axios.get("api/agendamento.php", {params: self.form})
                .then(response => {
                    
                    console.log("getAgendamentos() response", response);
                    self.data.agendamentos      = JSON.parse(JSON.stringify(response.data.result));
                    self.$root.tmp.dashboardAgendamentos = JSON.parse(JSON.stringify(response.data.result));

                    self.$forceUpdate(); 
                    // loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getAgendamentos() error", error.response);                    
                    // loading.hide();
                    resolve(error);
                    // reject(error);
                    // alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        }, 
        init: function() {
            console.log("init()");
            var self = this;
            loading.show();
            Promise.all([
                self.getAgendamentos(),
                self.getMural(),
            ]).then(function() {
                self.initLoaded = true;
                
                if (self.$root.loaded) {

                    console.log("loader hide 1")
                    loading.hide();
                }
            }).catch(function(error) {
                // loading.hide();
                self.initLoaded = true;
                self.$forceUpdate();  
                if (self.$root.loaded) {

                    console.log("loader hide 1")
                    loading.hide();
                }              
            });               
        }
    },
    created: function() {
        var self = this;
        if (!self.$root.loaded) {
            $("#wrapper").hide();
            loading.show();
        }
        window._swiper = self.$refs;

        if (self.$root.user.tipo == 'marketing') {
            self.$router.currentRoute.meta.title = "Área do marketing";
        }
        
        if (self.$root.user.tipo == 'contratante') {
            self.$router.currentRoute.meta.title = "Área do paciente";
        }
        
        if (self.$root.user.tipo == 'admin') {
            self.$router.currentRoute.meta.title = "Área de administração";
        }
                                
        if (self.$root.user.tipo == 'profissional') {
            self.$router.currentRoute.meta.title = "Área do profissional";
        }

        // if (self.$root.user.tipo == "contratante") {
        //     self.$root.getUser();
        // }
    },
    mounted: function() {
        
        var self = this;
        self.init();
        if (window.localStorage.getItem("_redirect")) {
            try {
                var redirect = JSON.parse(window.localStorage.getItem("_redirect"));
                if (redirect.route) {
                    redirect.query.r = 1;
                    console.log("Possui redirect", redirect)
                    setTimeout(function() {
                        self.$root.go(redirect.route, JSON.stringify(redirect.query));
                    }, 2000);
                }
            } catch(err) {
                console.log("Erro ao ler _redirect", err);
            }
        }
        setTimeout(function() {
            self.$root.loaded = true;
            $("#wrapper").fadeIn(1000);
            if (self.initLoaded) {
                loading.hide();
            }
            if (self.$refs.swiperConvenios) {
                setTimeout(function() {
                    self.$refs.swiperConvenios.update();
                    self.$refs.swiperConvenios.swiper.autoplay.run();
                }, 1000);
            }


        }, 500);
        // }, 2000);
        // setTimeout(function() {
        //     $(".dashboard-content-inner")[0].scrollTop = 0;
        // }, 100);


        if (self.$route.query.t == "popup-sintomas") {
            self.$root.openSintomas();             
        }
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .contato .social {
        display: inline-block;
        margin-right: 3px;
        margin-bottom: 10px;
    }

    .contato center img {
        width: auto;
        height: 13vh;
    }

    .contato small {
        margin-top: 5px;
        display: block;
        line-height: 110%;
        color: #666;
    }

    .contato .social img {
        width: 30px;
        margin: 0px;
        /*opacity: 0.3;*/
    }

/*    .job-listing-description small {
        color: #999;
        font-size: 12px;
    }

    .job-listing-description small i {
        font-size: 14px;
        top: 2px;
        position: relative;
    }*/

    .dashboard-sidebar {
        display: none;
    }  

    .convenios {
        border-color: #1d9dd9;
        min-height: 17vh; 
        height: 100%; 
        padding-top: 20px; 
        justify-content: flex-start !important; 
        vertical-align: top !important;
        background: #fff;
    }

    .convenios .swiper-container {
        /*margin-top: 10px;*/
    }
    .convenios a {
        font-size: 14px;
    }

    .convenios img {
        width: 200px;
    }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue